import {StoryInterface} from "../../interfaces/StoryInterface";
import fleetConnexMainPoster from "../../assets/fleetConnexMainVideoPoster.png";
import sailortalkMainVideoPoster from "../../assets/sailorTalkMainVideoPoster.png";
import partnershipVideo1Poster from "../../assets/partnershipVideo1Poster.png";
import partnershipVideo2Poster from "../../assets/partnershipVideo2Poster.png";

export const storiesReserve = [
    {
        id: 1,
        attributes: {
            title: "Happy Monday! ",
            subtitle: "#fleetsolutions #connectivity #4glte ",
            description: "Happy Monday! Another happy Fleet-Connex Customer, more than 10GBs used in the first 18 hours!\n\nFor inquiries email us at sales@pentonet.com",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_fleetsolutions-connectivity-4glte-activity-7053637340631613440-5xOq",
            createdAt: "2023-12-12T12:06:08.565Z",
            updatedAt: "2023-12-12T12:06:08.565Z",
            picture: {
                data: {
                    id: 1,
                    attributes: {
                        name: "storyImage1.jpeg",
                        alternativeText: null,
                        caption: null,
                        width: 921,
                        height: 1536,
                        formats: {
                            large: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "large_story_Image1_94a5cd6a2b",
                                mime: "image/jpeg",
                                name: "large_storyImage1.jpeg",
                                path: null,
                                size: 74.74,
                                width: 600,
                                height: 1000
                            },
                            small: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "small_story_Image1_94a5cd6a2b",
                                mime: "image/jpeg",
                                name: "small_storyImage1.jpeg",
                                path: null,
                                size: 23.08,
                                width: 299,
                                height: 500
                            },
                            medium: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "medium_story_Image1_94a5cd6a2b",
                                mime: "image/jpeg",
                                name: "medium_storyImage1.jpeg",
                                path: null,
                                size: 46.45,
                                width: 450,
                                height: 750
                            },
                            thumbnail: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "thumbnail_story_Image1_94a5cd6a2b",
                                mime: "image/jpeg",
                                name: "thumbnail_storyImage1.jpeg",
                                path: null,
                                size: 3.61,
                                width: 93,
                                height: 156
                            }
                        },
                        hash: "story_Image1_94a5cd6a2b",
                        ext: ".jpeg",
                        mime: "image/jpeg",
                        size: 150,
                        url: partnershipVideo2Poster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T12:06:04.857Z",
                        updatedAt: "2023-12-12T12:06:04.857Z"
                    }
                }
            }
        }
    },
    {
        id: 2,
        attributes: {
            title: "Why is Near Shore connectivity a MUST HAVE!",
            subtitle: "#4glte #vesselmanagement #communications #maritimeindustry ",
            description: " Invest in this valuable asset and enhance your connectivity around the World. This has to be a good strategy for any ship operator seeking to secure lines of communication between the ship and the office.",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_why-near-shore-connectivity-matters-activity-7057525867786240000-yhMF",
            createdAt: "2023-12-12T12:10:53.150Z",
            updatedAt: "2023-12-12T12:10:53.150Z",
            picture: {
                data: {
                    id: 2,
                    attributes: {
                        name: "partnershipVideo1Poster.png",
                        alternativeText: null,
                        caption: null,
                        width: 4112,
                        height: 2310,
                        formats: {
                            large: {
                                ext: ".png",
                                url: partnershipVideo2Poster,
                                hash: "large_partnership_Video1_Poster_c5bf375671",
                                mime: "image/png",
                                name: "large_partnershipVideo1Poster.png",
                                path: null,
                                size: 1175.37,
                                width: 1000,
                                height: 562
                            },
                            small: {
                                ext: ".png",
                                url: partnershipVideo2Poster,
                                hash: "small_partnership_Video1_Poster_c5bf375671",
                                mime: "image/png",
                                name: "small_partnershipVideo1Poster.png",
                                path: null,
                                size: 315.11,
                                width: 500,
                                height: 281
                            },
                            medium: {
                                ext: ".png",
                                url: partnershipVideo2Poster,
                                hash: "medium_partnership_Video1_Poster_c5bf375671",
                                mime: "image/png",
                                name: "medium_partnershipVideo1Poster.png",
                                path: null,
                                size: 678.93,
                                width: 750,
                                height: 421
                            },
                            thumbnail: {
                                ext: ".png",
                                url: partnershipVideo2Poster,
                                hash: "thumbnail_partnership_Video1_Poster_c5bf375671",
                                mime: "image/png",
                                name: "thumbnail_partnershipVideo1Poster.png",
                                path: null,
                                size: 82.06,
                                width: 245,
                                height: 138
                            }
                        },
                        hash: "partnership_Video1_Poster_c5bf375671",
                        ext: ".png",
                        mime: "image/png",
                        size: 3585.13,
                        url: partnershipVideo2Poster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T12:10:18.188Z",
                        updatedAt: "2023-12-12T12:10:18.188Z"
                    }
                }
            }
        }
    },
    {
        id: 3,
        attributes: {
            title: "Considering deploying one of the new LEO services?",
            subtitle: "#voip #shippingindustry #communications #satellitecommunications ",
            description: " Pentonet's ShipTalk VoIP product could be essential, as it provides high-quality, easy-to-deploy voice services for such networks.",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_shiptalk-activity-7064834062762340353-beR7",
            createdAt: "2023-12-12T12:13:30.895Z",
            updatedAt: "2023-12-12T12:13:30.895Z",
            picture: {
                data: {
                    id: 3,
                    attributes: {
                        name: "partnershipVideo2Poster.png",
                        alternativeText: null,
                        caption: null,
                        width: 4112,
                        height: 2310,
                        formats: {
                            large: {
                                ext: ".png",
                                url: partnershipVideo1Poster,
                                hash: "large_partnership_Video2_Poster_425ee517c3",
                                mime: "image/png",
                                name: "large_partnershipVideo2Poster.png",
                                path: null,
                                size: 868.77,
                                width: 1000,
                                height: 562
                            },
                            small: {
                                ext: ".png",
                                url: partnershipVideo1Poster,
                                hash: "small_partnership_Video2_Poster_425ee517c3",
                                mime: "image/png",
                                name: "small_partnershipVideo2Poster.png",
                                path: null,
                                size: 238.87,
                                width: 500,
                                height: 281
                            },
                            medium: {
                                ext: ".png",
                                url: partnershipVideo1Poster,
                                hash: "medium_partnership_Video2_Poster_425ee517c3",
                                mime: "image/png",
                                name: "medium_partnershipVideo2Poster.png",
                                path: null,
                                size: 503.84,
                                width: 750,
                                height: 421
                            },
                            thumbnail: {
                                ext: ".png",
                                url: partnershipVideo1Poster,
                                hash: "thumbnail_partnership_Video2_Poster_425ee517c3",
                                mime: "image/png",
                                name: "thumbnail_partnershipVideo2Poster.png",
                                path: null,
                                size: 66.06,
                                width: 245,
                                height: 138
                            }
                        },
                        hash: "partnership_Video2_Poster_425ee517c3",
                        ext: ".png",
                        mime: "image/png",
                        size: 2776.79,
                        url: partnershipVideo1Poster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T12:13:22.056Z",
                        updatedAt: "2023-12-12T12:13:22.056Z"
                    }
                }
            }
        }
    },
    {
        id: 4,
        attributes: {
            title: "#FLEETCONNEX",
            subtitle: "#nearshoreconnectivity #4glte #maritimeindustry #shippingsolutions #globalconnectivity ",
            description: " It's great to provide a valuable service, and even better to feel appreciated for doing so! #FLEETCONNEX",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_fleetconnex-nearshoreconnectivity-4glte-activity-7068829188731908097-Bj4j",
            createdAt: "2023-12-12T12:15:08.121Z",
            updatedAt: "2023-12-12T12:15:08.121Z",
            picture: {
                data: {
                    id: 4,
                    attributes: {
                        name: "1685340210423.jpeg",
                        alternativeText: null,
                        caption: null,
                        width: 1080,
                        height: 1920,
                        formats: {
                            large: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "large_1685340210423_c1b1a2a4df",
                                mime: "image/jpeg",
                                name: "large_1685340210423.jpeg",
                                path: null,
                                size: 77.51,
                                width: 563,
                                height: 1000
                            },
                            small: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "small_1685340210423_c1b1a2a4df",
                                mime: "image/jpeg",
                                name: "small_1685340210423.jpeg",
                                path: null,
                                size: 24.27,
                                width: 281,
                                height: 500
                            },
                            medium: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "medium_1685340210423_c1b1a2a4df",
                                mime: "image/jpeg",
                                name: "medium_1685340210423.jpeg",
                                path: null,
                                size: 48.11,
                                width: 422,
                                height: 750
                            },
                            thumbnail: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "thumbnail_1685340210423_c1b1a2a4df",
                                mime: "image/jpeg",
                                name: "thumbnail_1685340210423.jpeg",
                                path: null,
                                size: 3.57,
                                width: 88,
                                height: 156
                            }
                        },
                        hash: "1685340210423_c1b1a2a4df",
                        ext: ".jpeg",
                        mime: "image/jpeg",
                        size: 210.36,
                        url: partnershipVideo2Poster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T12:15:03.701Z",
                        updatedAt: "2023-12-12T12:15:03.701Z"
                    }
                }
            }
        }
    },
    {
        id: 5,
        attributes: {
            title: "Connect your vessel and cure for less!",
            subtitle: null,
            description: "In today's digital age, where communication with your vessel’s crew largely happen through instant messaging, emails, and video calls, the significance of voice calls may appear diminished. However, voice calls continue to play a crucial role in business and personal communications at sea. In such remote locations, where reliable internet connectivity may be limited, voice calls provide a reliable and immediate means of communication. They enable real-time coordination, ensuring the safety and efficiency of maritime operations. Voice calls allow foster clearer and more nuanced conversations, allowing for quick decision-making and problem-solving. Additionally, voice calls facilitate interpersonal connections among seafarers, reducing feelings of isolation during long voyages. In the maritime world, the humble voice call remains an invaluable tool in an increasingly digital landscape.",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_in-todays-digital-age-where-communication-activity-7085945985457098752-lWIs",
            createdAt: "2023-12-12T12:17:44.184Z",
            updatedAt: "2023-12-12T12:17:44.184Z",
            picture: {
                data: {
                    id: 5,
                    attributes: {
                        name: "sailorTalkMainVideoPoster.png",
                        alternativeText: null,
                        caption: null,
                        width: 4100,
                        height: 2290,
                        formats: {
                            large: {
                                ext: ".png",
                                url: sailortalkMainVideoPoster,
                                hash: "large_sailor_Talk_Main_Video_Poster_feffd77a74",
                                mime: "image/png",
                                name: "large_sailorTalkMainVideoPoster.png",
                                path: null,
                                size: 439.18,
                                width: 1000,
                                height: 559
                            },
                            small: {
                                ext: ".png",
                                url: sailortalkMainVideoPoster,
                                hash: "small_sailor_Talk_Main_Video_Poster_feffd77a74",
                                mime: "image/png",
                                name: "small_sailorTalkMainVideoPoster.png",
                                path: null,
                                size: 128.39,
                                width: 500,
                                height: 279
                            },
                            medium: {
                                ext: ".png",
                                url: sailortalkMainVideoPoster,
                                hash: "medium_sailor_Talk_Main_Video_Poster_feffd77a74",
                                mime: "image/png",
                                name: "medium_sailorTalkMainVideoPoster.png",
                                path: null,
                                size: 257.13,
                                width: 750,
                                height: 419
                            },
                            thumbnail: {
                                ext: ".png",
                                url: sailortalkMainVideoPoster,
                                hash: "thumbnail_sailor_Talk_Main_Video_Poster_feffd77a74",
                                mime: "image/png",
                                name: "thumbnail_sailorTalkMainVideoPoster.png",
                                path: null,
                                size: 39.9,
                                width: 245,
                                height: 137
                            }
                        },
                        hash: "sailor_Talk_Main_Video_Poster_feffd77a74",
                        ext: ".png",
                        mime: "image/png",
                        size: 1502.55,
                        url: sailortalkMainVideoPoster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T12:17:36.583Z",
                        updatedAt: "2023-12-12T12:17:36.583Z"
                    }
                }
            }
        }
    },
    {
        id: 6,
        attributes: {
            title: "In 2023 crews  should be a priority in the industry.",
            subtitle: null,
            description: "The study, supported by NorthStandard and Idwal, captured sentiments across a broad range of welfare issues and revealed a dip in overall happiness from 7.69 to 7.1 out of 10 compared to Q4 2022.\n\nThe survey found that seafarers’ satisfaction levels fell in nine out of ten surveyed areas. Key concerns included shore leave access, sign-on and sign-off procedures, inadequate food provisions, bureaucratic paperwork, ineffective leadership, and social isolation. Furthermore, disparities in health and well-being programs, dental care access, mental health support, and career advancement opportunities were also reported.\n\nDespite the decline, seafarers acknowledged the importance of positive onboard interactions for their wellbeing and job satisfaction. However, a lack of entertainment options and shared spaces onboard ships has hindered their ability to engage in social activities.\n\nRevd Canon Andrew Wright, Secretary General of The Mission to Seafarers, said the decline in the satisfaction of seafarers following steady improvements throughout 2022 illustrates the importance of maintaining momentum on seafarer welfare and addressing challenges collaboratively.\n\nThom Herbert, Idwal Senior Marine Surveyor and Crew Welfare Advocate, called for a focus on improving nutrition and meal quality to promote onboard culture and camaraderie.\n\n“Moving out of the pandemic does not make lack of shore leave any less of an issue and we need to keep a spotlight on this to ensure it improves,” said Herbert.\n\n“As a former seafarer, I know how important good nutrition and good food is to keep you healthy and motivated. Good meal times together can also go a long way to help the onboard culture and camaraderie. Getting food right for people is basic and we should be doing better,” Herbert added.\n\nCaptain Yves Vandenborn, Director of Loss Prevention at NorthStandard, urged companies to prioritize wellbeing aspects to improve job satisfaction, productivity, and retention among seafarers.\n\n“Persistent frustrations with shore leave and challenges with extended periods on board appear to have had a negative impact on scoring as the pace of industry-wide improvement to these areas has been slow,” said Capt. Vandenborn.\n\nDuring Singapore Maritime Week 2023, The Mission to Seafarers, NorthStandard, Idwal, Inmarsat, and SHI founder Steven Jones hosted an Executive Roundtable on Crew Welfare, aiming to develop a solutions-centered approach to seafarer well-being. The group seeks to accelerate the shipping industry’s transition from compliance to excellence by prioritizing crew welfare and creating real-world shipboard solutions that challenge the status quo.\n\nThe Mission to Seafarers hopes that by drawing attention to these challenges and fostering collaboration, the shipping industry can improve seafarer welfare and happiness, leading to a more sustainable, equitable, and humane industry for all stakeholders.",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_seafarer-happiness-declines-shipping-industry-activity-7094661188810108928-jXd3",
            createdAt: "2023-12-12T12:19:46.427Z",
            updatedAt: "2023-12-12T12:19:46.427Z",
            picture: {
                data: {
                    id: 6,
                    attributes: {
                        name: "1701741878532.jpeg",
                        alternativeText: null,
                        caption: null,
                        width: 1000,
                        height: 667,
                        formats: {
                            small: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "small_1701741878532_e0a5a18f37",
                                mime: "image/jpeg",
                                name: "small_1701741878532.jpeg",
                                path: null,
                                size: 26.66,
                                width: 500,
                                height: 334
                            },
                            medium: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "medium_1701741878532_e0a5a18f37",
                                mime: "image/jpeg",
                                name: "medium_1701741878532.jpeg",
                                path: null,
                                size: 49.4,
                                width: 750,
                                height: 500
                            },
                            thumbnail: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "thumbnail_1701741878532_e0a5a18f37",
                                mime: "image/jpeg",
                                name: "thumbnail_1701741878532.jpeg",
                                path: null,
                                size: 8.89,
                                width: 234,
                                height: 156
                            }
                        },
                        hash: "1701741878532_e0a5a18f37",
                        ext: ".jpeg",
                        mime: "image/jpeg",
                        size: 68.27,
                        url: partnershipVideo2Poster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T12:19:40.582Z",
                        updatedAt: "2023-12-12T12:19:40.582Z"
                    }
                }
            }
        }
    },
    {
        id: 7,
        attributes: {
            title: "SMAGIC23",
            subtitle: "#SMAGIC23 #smartmaritimenetwork",
            description: "Will be attending SMAGIC in Copenhagen this week and look forward to catching up with all things smart and maritime related. ",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_looking-forward-to-some-interesting-discussions-activity-7111980567251869696-46p4",
            createdAt: "2023-12-12T13:05:33.667Z",
            updatedAt: "2023-12-12T13:05:33.667Z",
            picture: {
                data: {
                    id: 7,
                    attributes: {
                        name: "1695628258005.jpeg",
                        alternativeText: null,
                        caption: null,
                        width: 1080,
                        height: 1080,
                        formats: {
                            large: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "large_1695628258005_f152e33c37",
                                mime: "image/jpeg",
                                name: "large_1695628258005.jpeg",
                                path: null,
                                size: 180.62,
                                width: 1000,
                                height: 1000
                            },
                            small: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "small_1695628258005_f152e33c37",
                                mime: "image/jpeg",
                                name: "small_1695628258005.jpeg",
                                path: null,
                                size: 58.02,
                                width: 500,
                                height: 500
                            },
                            medium: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "medium_1695628258005_f152e33c37",
                                mime: "image/jpeg",
                                name: "medium_1695628258005.jpeg",
                                path: null,
                                size: 114.04,
                                width: 750,
                                height: 750
                            },
                            thumbnail: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "thumbnail_1695628258005_f152e33c37",
                                mime: "image/jpeg",
                                name: "thumbnail_1695628258005.jpeg",
                                path: null,
                                size: 7.35,
                                width: 156,
                                height: 156
                            }
                        },
                        hash: "1695628258005_f152e33c37",
                        ext: ".jpeg",
                        mime: "image/jpeg",
                        size: 201.52,
                        url: partnershipVideo2Poster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T13:05:02.564Z",
                        updatedAt: "2023-12-12T13:05:02.564Z"
                    }
                }
            }
        }
    },
    {
        id: 8,
        attributes: {
            title: "Are you having trouble with your connectivity onboard?",
            subtitle: "#communication #nearshoreconnectivity #maritimeindustry #vessel #shippingindustry #globalconnectivity #shipowners ",
            description: "Are you having trouble with your connectivity onboard? Or simply looking for enhanced solutions for your Ship #connectivity?\n\nAt Pentonet we have been solving these problems for years and offer essential communication services for ships and crews of all sizes! Our connectivity solutions- Fleet-Connex, Shiptalk, and SailorTalk, provide #nearshore LTE, flexible light VoIP, and crew SIM solutions that could be just the thing to help you! \n\nGet in touch with us at sales@pentonet.com to see which of these may be best suited to you or check them out at www.pentonet.com.\n\nStay connected! Improve your ship operations, care for your crew, and achieve your business goals for #2023 with us!\n",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_pentonet-activity-7027169318324903936-VmGh",
            createdAt: "2023-12-12T13:07:48.309Z",
            updatedAt: "2023-12-12T13:07:48.309Z",
            picture: {
                data: {
                    id: 8,
                    attributes: {
                        name: "fleetConnexMainVideoPoster.png",
                        alternativeText: null,
                        caption: null,
                        width: 4112,
                        height: 2292,
                        formats: {
                            large: {
                                ext: ".png",
                                url: fleetConnexMainPoster,
                                hash: "large_fleet_Connex_Main_Video_Poster_5c42e0b1b6",
                                mime: "image/png",
                                name: "large_fleetConnexMainVideoPoster.png",
                                path: null,
                                size: 960.78,
                                width: 1000,
                                height: 557
                            },
                            small: {
                                ext: ".png",
                                url: fleetConnexMainPoster,
                                hash: "small_fleet_Connex_Main_Video_Poster_5c42e0b1b6",
                                mime: "image/png",
                                name: "small_fleetConnexMainVideoPoster.png",
                                path: null,
                                size: 263.39,
                                width: 500,
                                height: 279
                            },
                            medium: {
                                ext: ".png",
                                url: fleetConnexMainPoster,
                                hash: "medium_fleet_Connex_Main_Video_Poster_5c42e0b1b6",
                                mime: "image/png",
                                name: "medium_fleetConnexMainVideoPoster.png",
                                path: null,
                                size: 559.12,
                                width: 750,
                                height: 418
                            },
                            thumbnail: {
                                ext: ".png",
                                url: fleetConnexMainPoster,
                                hash: "thumbnail_fleet_Connex_Main_Video_Poster_5c42e0b1b6",
                                mime: "image/png",
                                name: "thumbnail_fleetConnexMainVideoPoster.png",
                                path: null,
                                size: 70.87,
                                width: 245,
                                height: 137
                            }
                        },
                        hash: "fleet_Connex_Main_Video_Poster_5c42e0b1b6",
                        ext: ".png",
                        mime: "image/png",
                        size: 2916.58,
                        url: fleetConnexMainPoster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T13:07:43.855Z",
                        updatedAt: "2023-12-12T13:07:43.855Z"
                    }
                }
            }
        }
    },
    {
        id: 9,
        attributes: {
            title: "Welcome and Godspeed! ",
            subtitle: null,
            description: "Hi all, Pentonet is very pleased to announce that Henri M. will be joining us as a CCO. He will too join the Company's management team and focus on commercializing our products and platform in the maritime space. ",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_we-are-happy-onboard-henri-manner-as-chief-activity-7133785083857022976-Yyw-",
            createdAt: "2023-12-12T13:09:09.939Z",
            updatedAt: "2023-12-12T13:09:09.939Z",
            picture: {
                data: {
                    id: 9,
                    attributes: {
                        name: "1700826880952.jpeg",
                        alternativeText: null,
                        caption: null,
                        width: 1280,
                        height: 720,
                        formats: {
                            large: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "large_1700826880952_9b7051f6f6",
                                mime: "image/jpeg",
                                name: "large_1700826880952.jpeg",
                                path: null,
                                size: 26.65,
                                width: 1000,
                                height: 563
                            },
                            small: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "small_1700826880952_9b7051f6f6",
                                mime: "image/jpeg",
                                name: "small_1700826880952.jpeg",
                                path: null,
                                size: 10.56,
                                width: 500,
                                height: 281
                            },
                            medium: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "medium_1700826880952_9b7051f6f6",
                                mime: "image/jpeg",
                                name: "medium_1700826880952.jpeg",
                                path: null,
                                size: 17.85,
                                width: 750,
                                height: 422
                            },
                            thumbnail: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "thumbnail_1700826880952_9b7051f6f6",
                                mime: "image/jpeg",
                                name: "thumbnail_1700826880952.jpeg",
                                path: null,
                                size: 4.02,
                                width: 245,
                                height: 138
                            }
                        },
                        hash: "1700826880952_9b7051f6f6",
                        ext: ".jpeg",
                        mime: "image/jpeg",
                        size: 27.25,
                        url: partnershipVideo2Poster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T13:08:59.263Z",
                        updatedAt: "2023-12-12T13:08:59.263Z"
                    }
                }
            }
        }
    },
    {
        id: 10,
        attributes: {
            title: "We are excited to announce that the brand new Pentonet website is officially live! ",
            subtitle: null,
            description: "We are excited to announce that the brand new Pentonet website is officially live! \n\nAs our World is more and more on the move and digital so we want to provide You a user experience that reflects this. Especially we have focused on the mobile devices to bring you a seamless browsing experience that reflects our “Customer First” company culture.\n\nExplore our user-friendly interface, discover our leading maritime connectivity products and yes please do connect with us. Engage with us and let us know Your thoughts!\n\nLink to website at the comments! ",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_we-are-excited-to-announce-that-the-brand-activity-7133791624668532736-JaSW",
            createdAt: "2023-12-12T13:10:29.203Z",
            updatedAt: "2023-12-12T13:10:29.203Z",
            picture: {
                data: {
                    id: 10,
                    attributes: {
                        name: "1700828462020.jpeg",
                        alternativeText: null,
                        caption: null,
                        width: 1200,
                        height: 627,
                        formats: {
                            large: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "large_1700828462020_5c0b96041f",
                                mime: "image/jpeg",
                                name: "large_1700828462020.jpeg",
                                path: null,
                                size: 123.54,
                                width: 1000,
                                height: 523
                            },
                            small: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "small_1700828462020_5c0b96041f",
                                mime: "image/jpeg",
                                name: "small_1700828462020.jpeg",
                                path: null,
                                size: 38.88,
                                width: 500,
                                height: 261
                            },
                            medium: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "medium_1700828462020_5c0b96041f",
                                mime: "image/jpeg",
                                name: "medium_1700828462020.jpeg",
                                path: null,
                                size: 75.85,
                                width: 750,
                                height: 392
                            },
                            thumbnail: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "thumbnail_1700828462020_5c0b96041f",
                                mime: "image/jpeg",
                                name: "thumbnail_1700828462020.jpeg",
                                path: null,
                                size: 11.31,
                                width: 245,
                                height: 128
                            }
                        },
                        hash: "1700828462020_5c0b96041f",
                        ext: ".jpeg",
                        mime: "image/jpeg",
                        size: 164.59,
                        url: partnershipVideo2Poster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T13:10:25.954Z",
                        updatedAt: "2023-12-12T13:10:25.954Z"
                    }
                }
            }
        }
    },
    {
        id: 11,
        attributes: {
            title: "Our Commercial Team on the Road @Singapore. ",
            subtitle: "#maritimeindustry #maritimeinnovation  #maritimetechnology  #leadership",
            description: "We are here Smart Maritime Network the top-3 take aways are: \n\n1. From Ship Owners perspective connectivity has to solve real problems (not just to add another layer of cost on top of the OPEX-cake <Operational Expenditures>) - very very important! Thank You for Mr Himanshu Chopra for straight talk.\n2. Every ship owner / shipping line is at the different point of connectivity deployment curve - There’s no silver bullet that solves everyone’s needs - very well said Mr. Chakib Abi-Saab.\n3. Leadership and connectivity. Better bandwidth will bring Netflix etc to the seafarers reach but the golden rule of reciprocity needs to be at the core of the wellbeing of the seafarers; treat your crew like you treat your own family. \n\nPentonet value proposition is delivering value on these current maritime hot buttons:\n\n1. 92% Cost Saving Potential via our FleetConnec system. For the details see the next picture what our FleetConnex enables e.g. here in APAC-region. Those of who with sharp eyes - yes we’ve made the study already few years ago. Fast forward today consumption has gone up so in fact the benefits are even better.\n2. Pentonet is a customer-driven company. We are able to tailor made the right solution for you depending where you are at your digitalization deployment initiative.\n3. Thank You Capt. Hari Subramaniam for sharing this. We find your leadership view excellent. Connectivity is an enabler here and we humans being the Captains where to direct the industry.",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_our-commercial-team-on-the-road-singapore-activity-7135534161229979648-BL0f",
            createdAt: "2023-12-12T13:11:36.825Z",
            updatedAt: "2023-12-12T13:11:36.825Z",
            picture: {
                data: {
                    id: 11,
                    attributes: {
                        name: "1701243636399.jpeg",
                        alternativeText: null,
                        caption: null,
                        width: 800,
                        height: 638,
                        formats: {
                            small: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "small_1701243636399_abdf8d9537",
                                mime: "image/jpeg",
                                name: "small_1701243636399.jpeg",
                                path: null,
                                size: 44.36,
                                width: 500,
                                height: 399
                            },
                            medium: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "medium_1701243636399_abdf8d9537",
                                mime: "image/jpeg",
                                name: "medium_1701243636399.jpeg",
                                path: null,
                                size: 88.73,
                                width: 750,
                                height: 598
                            },
                            thumbnail: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "thumbnail_1701243636399_abdf8d9537",
                                mime: "image/jpeg",
                                name: "thumbnail_1701243636399.jpeg",
                                path: null,
                                size: 9.26,
                                width: 196,
                                height: 156
                            }
                        },
                        hash: "1701243636399_abdf8d9537",
                        ext: ".jpeg",
                        mime: "image/jpeg",
                        size: 99.06,
                        url: partnershipVideo2Poster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T13:11:30.334Z",
                        updatedAt: "2023-12-12T13:11:30.334Z"
                    }
                }
            }
        }
    },
    {
        id: 12,
        attributes: {
            title: "Trevor Whitworth. ",
            subtitle: null,
            description: "Straight-forward good thoughts from our Commercial Director Trevor Whitworth. Please watch and engage with Trevor; he is great chap 😊 !",
            linkedInLink: "https://www.linkedin.com/posts/pentonet_straight-forward-good-thoughts-from-our-commercial-activity-7136232596547526656-cAxQ",
            createdAt: "2023-12-12T13:13:05.520Z",
            updatedAt: "2023-12-12T13:13:05.520Z",
            picture: {
                data: {
                    id: 12,
                    attributes: {
                        name: "1701409410280.jpeg",
                        alternativeText: null,
                        caption: null,
                        width: 1280,
                        height: 720,
                        formats: {
                            large: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "large_1701409410280_8af556c4d3",
                                mime: "image/jpeg",
                                name: "large_1701409410280.jpeg",
                                path: null,
                                size: 36.66,
                                width: 1000,
                                height: 563
                            },
                            small: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "small_1701409410280_8af556c4d3",
                                mime: "image/jpeg",
                                name: "small_1701409410280.jpeg",
                                path: null,
                                size: 14.65,
                                width: 500,
                                height: 281
                            },
                            medium: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "medium_1701409410280_8af556c4d3",
                                mime: "image/jpeg",
                                name: "medium_1701409410280.jpeg",
                                path: null,
                                size: 25.18,
                                width: 750,
                                height: 422
                            },
                            thumbnail: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "thumbnail_1701409410280_8af556c4d3",
                                mime: "image/jpeg",
                                name: "thumbnail_1701409410280.jpeg",
                                path: null,
                                size: 4.99,
                                width: 245,
                                height: 138
                            }
                        },
                        hash: "1701409410280_8af556c4d3",
                        ext: ".jpeg",
                        mime: "image/jpeg",
                        size: 32.91,
                        url: partnershipVideo2Poster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T13:12:59.202Z",
                        updatedAt: "2023-12-12T13:12:59.202Z"
                    }
                }
            }
        }
    },
    {
        id: 13,
        attributes: {
            title: "6.12.2023 Happy Independence Day Finland - Steady As She Goes.",
            subtitle: "#maritimeindustry #maritimelogistics #finlandworks #finland ",
            description: "6-12-2023 Happy Independence Day Finland 🇫🇮! \n\nYesterday we had the pleasure of having ESL Shipping Ltd  Beauty EIRA visiting us here in Jätkäsaari, Helsinki. Today She’s already in Pori.\n\nInteresting Short Story: \n\nWe have had many many years the pleasure to welcome 🚢 Eira and its colleagues 🚢 Viikki and 🚢 Pasila to visit us. They have been transporting coal almost weekly for the needs of the Hanasaari and Salmisaari power plants to generate energy for us Helsinkians 😊😊😊.\n\nBut on May Day 2029, coal transport will end as the Finnish parliament approved coal burning ban comes into effect. \n\nDoes Eira's journey end here?\n\nLuckily not as there are many greener pastures to ship. Steady as She Goes, just like Finland 🇫🇮, where we celebrate the #️⃣1️⃣0️⃣6️⃣ Independence Day ❤️🇫🇮.\n",
            linkedInLink: "https://www.linkedin.com/feed/update/urn:li:activity:7138423103143010304",
            createdAt: "2023-12-12T13:14:45.466Z",
            updatedAt: "2023-12-12T13:14:45.466Z",
            picture: {
                data: {
                    id: 13,
                    attributes: {
                        name: "1701863557516.jpeg",
                        alternativeText: null,
                        caption: null,
                        width: 1280,
                        height: 720,
                        formats: {
                            large: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "large_1701863557516_5c75f4ad09",
                                mime: "image/jpeg",
                                name: "large_1701863557516.jpeg",
                                path: null,
                                size: 70.3,
                                width: 1000,
                                height: 563
                            },
                            small: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "small_1701863557516_5c75f4ad09",
                                mime: "image/jpeg",
                                name: "small_1701863557516.jpeg",
                                path: null,
                                size: 23.8,
                                width: 500,
                                height: 281
                            },
                            medium: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "medium_1701863557516_5c75f4ad09",
                                mime: "image/jpeg",
                                name: "medium_1701863557516.jpeg",
                                path: null,
                                size: 45.15,
                                width: 750,
                                height: 422
                            },
                            thumbnail: {
                                ext: ".jpeg",
                                url: partnershipVideo2Poster,
                                hash: "thumbnail_1701863557516_5c75f4ad09",
                                mime: "image/jpeg",
                                name: "thumbnail_1701863557516.jpeg",
                                path: null,
                                size: 7.45,
                                width: 245,
                                height: 138
                            }
                        },
                        hash: "1701863557516_5c75f4ad09",
                        ext: ".jpeg",
                        mime: "image/jpeg",
                        size: 62.99,
                        url: partnershipVideo2Poster,
                        previewUrl: null,
                        provider: "strapi-provider-upload-strapi-cloud",
                        provider_metadata: null,
                        createdAt: "2023-12-12T13:14:42.403Z",
                        updatedAt: "2023-12-12T13:14:42.403Z"
                    }
                }
            }
        }
    }
] as StoryInterface[];